<div class="card">
  <div class="card-body">
    <h5>{{ "Danh Sách Hoá Đơn" | translate }}</h5>
    <div class="">
      <div class="row">
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Chọn trạng thái đơn hàng" | translate
          }}</label>
          <ng-select
            [(ngModel)]="filter.is_replaced"
            [clearable]="true"
            (change)="submitFilter()"
          >
            <ng-option value="" hidden>{{
              "Trạng thái đơn hàng" | translate
            }}</ng-option>
            <ng-option
              *ngFor="let item of listStatusOrder"
              [value]="item.value"
              >{{ item.label }}</ng-option
            >
          </ng-select>
        </div>
        <!-- <div class="form-group col-3">
            <mat-form-field appearance="fill" class="mt-3">
              <mat-label>Chọn khoảng ngày </mat-label>
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Ngày bắt đầu" />
                <input matEndDate formControlName="end" placeholder="Ngày kết thúc" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
              <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
              <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
            </mat-form-field>
          </div> -->
        <div class="form-group col-md-3 d-flex">
          <div class="col-4">
            <div style="min-width: 200px">
              <div class="form-group">
                <label for="validationCustom01" class="d-block">&nbsp;</label>
                <button class="btn btn-primary" (click)="submitFilter()">
                  {{ "PAGE.REPORT.Search" | translate }}
                </button>
                <button
                  class="btn btn-dark ml-2"
                  *ngIf="searching"
                  (click)="clearFilter()"
                >
                  {{ "FORM.Clear" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <!-- <th width="100">
              {{ "Quản lý" | translate }}
            </th> -->
            <th class="first-column">{{ "Tên KH" | translate }}</th>
            <th>{{ "Số tài khoản" | translate }}</th>
            <th>{{ "Số điện thoại" | translate }}</th>
            <th>{{ "CCCD" | translate }}</th>
            <th>{{ "MST" | translate }}</th>
            <th>{{ "Mã hoá đơn" | translate }}</th>
            <th>{{ "Loại TB" | translate }}</th>
            <th>{{ "Gói DV" | translate }}</th>
            <th>{{ "Số tiền" | translate }}</th>
            <th>{{ "Trạng thái" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column">
              {{ pageSize * (pageIndex - 1) + i + 1 }}
            </td>
            <!-- <td class="py-2 table-column">
              <div class="d-flex" style="gap: 5px">
                <a
                  class="font-size-18 text-primary"
                  ngbTooltip="{{ 'Chi tiết' | translate }}"
                  placement="left"
                  (click)="viewDetails(data)"
                >
                  <i class="mdi mdi-eye"></i>
                </a>
                <a
                  *ngIf="data.invoice_no"
                  class="font-size-18 text-success"
                  ngbTooltip="{{ 'Tải hoá đơn' | translate }}"
                  placement="left"
                  (click)="exportInvoice(data.invoice_no)"
                >
                  <i class="mdi mdi-file-download"></i>
                </a>
                <a
                  class="font-size-18 text-primary"
                  *ngIf="data.order_status === 'refunded'"
                  ngbTooltip="{{ 'Tạo hoá đơn thay thế' | translate }}"
                  placement="left"
                  (click)="onEdit(data, updateInvoice)"
                >
                  <i class="mdi mdi-refresh"></i>
                </a>
              </div>
            </td> -->
            <td class="table-column">{{ data.full_name }}</td>
            <td class="table-column">{{ data.terminal_bank_acc }}</td>
            <td class="table-column">{{ data.phone }}</td>
            <td class="table-column">{{ data.cccd }}</td>
            <td class="table-column">{{ data.tax_code }}</td>
            <td class="table-column">{{ data.invoice_no || "Chưa có" }}</td>
            <td class="table-column">
              {{ data.device_type_name }}
            </td>

            <td class="table-column">
              <span class="font-size-12" *ngIf="data.original_duration == 3">{{
                "Gói 3 tháng" | translate
              }}</span>
              <span class="font-size-12" *ngIf="data.original_duration == 6">{{
                "Gói 6 tháng" | translate
              }}</span>
              <span *ngIf="data.original_duration == 12" class="font-size-12">{{
                "Gói 12 tháng" | translate
              }}</span>
            </td>
            <td class="table-column">
              {{ data.amount | currency : "VND" : "symbol" : "1.0-0" }}
            </td>
            <td class="table-column">
              <span
                class="badge font-size-12"
                [ngClass]="{
                  'badge-primary': data.invoice_status === 'Chờ phát hành',
                  'badge-success': data.invoice_status === 'Đã phát hành',
                  'badge-warning': data.invoice_status === 'Chưa đạt điều kiện',
                  'badge-danger': data.invoice_status === 'Lỗi',
                  'badge-secondary bg-danger': !data.invoice_status
                }"
              >
                {{ data.invoice_status || "Không xác định" }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contentSentMess role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Gửi tin nhắn tới khách hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="sendToUsers(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-12 col-form-label required_label">
              {{ "Số lượng khách hàng gửi" | translate }}
            </label>
            <div class="col-md-12">
              <input
                type="number"
                class="form-control"
                formControlName="data"
                min="1"
                max="100"
                [ngClass]="{
                  'is-invalid': submitted && formData.controls.data.invalid
                }"
              />
              <div
                *ngIf="submitted && formData.controls.data.invalid"
                class="invalid-feedback"
              >
                <div *ngIf="formData.controls.data.errors?.required">
                  Giá trị là bắt buộc.
                </div>
                <div *ngIf="formData.controls.data.errors?.min">
                  Giá trị phải không nhỏ hơn 1.
                </div>
                <div *ngIf="formData.controls.data.errors?.max">
                  Giá trị phải không lớn hơn 100.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Gửi" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #updateInvoice role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật hoá đơn thay thế và hoá đơn phí</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form
        (ngSubmit)="createReplacementInvoiceDraft(formData.value)"
        [formGroup]="formData"
      >
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-12 col-form-label required_label">
              {{ "Nhập giá tiền mới" | translate }}
            </label>
            <div class="col-md-12">
              <input
                type="number"
                class="form-control"
                formControlName="fee_amount"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.controls.fee_amount.invalid
                }"
              />
              <div
                *ngIf="submitted && formData.controls.fee_amount.invalid"
                class="invalid-feedback"
              >
                <div *ngIf="formData.controls.data.errors?.required">
                  Giá trị là bắt buộc.
                </div>
                <div *ngIf="formData.controls.data.errors?.min">
                  Giá trị phải không nhỏ hơn 1.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Gửi" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
